import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "searchForm" ]

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.searchFormTarget.requestSubmit()
    }, 500)
  }
}
